import types from './types'

// Checkout Fetch
export const checkoutSummary = (payload) => ({
  type: types.CHECKOUT_SUMMARY, payload
})
export const checkoutSummaryResponse = (payload) => ({
  type: types.CHECKOUT_SUMMARY_RESPONSE, payload
})
export const checkoutSummaryClear = () => ({ type: types.CHECKOUT_SUMMARY_CLEAR })

export const fetchPaymentIntent = (payload) => ({type: types.PAYMENT_INTENT, payload})
export const fetchPaymentIntentResponse = (payload) => ({type: types.PAYMENT_INTENT_RESPONSE, payload})
export const fetchPaymentIntentClear = () => ({ type: types.PAYMENT_INTENT_CLEAR })

export const fetchProductPI = (payload) => ({type: types.FETCH_PRODUCT_PI, payload})
export const fetchProductPIResponse = (payload) => ({type: types.FETCH_PRODUCT_PI_RES, payload})
export const fetchProductPIClear = () => ({ type: types.FETCH_PRODUCT_PI_CLEAR })

// Direct Checkout
export const fetchPIDirectCheckout = (payload) => ({type: types.PI_DIRECT_CHECKOUT, payload})
export const fetchPIDirectCheckoutResponse = (payload) => ({type: types.PI_DIRECT_CHECKOUT_RESPONSE, payload})
export const fetchPIDirectCheckoutClear = () => ({ type: types.PI_DIRECT_CHECKOUT_CLEAR })

// Provider Checkout
export const fetchProviderCheckout = (payload) => ({type: types.PROVIDER_CHECKOUT, payload})
export const fetchProviderCheckoutResponse = (payload) => ({type: types.PROVIDER_CHECKOUT_RESPONSE, payload})
export const fetchProviderCheckoutClear = () => ({ type: types.PROVIDER_CHECKOUT_CLEAR })

// Provider PlaceOrder
export const getProviderPlaceOrder = (payload) => ({type: types.PROVIDER_PLACEORDER, payload})
export const getProviderPlaceOrderResponse = (payload) => ({type: types.PROVIDER_PLACEORDER_RESPONSE, payload})
export const getProviderPlaceOrderClear = () => ({ type: types.PROVIDER_PLACEORDER_CLEAR })

export const getProviderPlaceOrderV2 = (payload) => ({type: types.PROVIDER_PLACEORDER_V2, payload})
export const getProviderPlaceOrderV2Response = (payload) => ({type: types.PROVIDER_PLACEORDER_V2_RESPONSE, payload})
export const getProviderPlaceOrderV2Clear = () => ({ type: types.PROVIDER_PLACEORDER_V2_CLEAR })

export const sendOrderPlaceResponse = (payload) => ({
  type: types.SEND_ORDER_PLACE_RESPONSE, payload
})

export const sendOrderPlace = (payload) => ({
  type: types.SEND_ORDER_PLACE, payload
})

export const sendOrderPlaceClear = () => ({ type: types.SEND_ORDER_PLACE_CLEAR })

export const zeroSendOrderResponse = (payload) => ({
  type: types.ZERO_SEND_ORDER_PLACE_RESPONSE, payload
})

export const zeroSendOrder = (payload) => ({
  type: types.ZERO_SEND_ORDER_PLACE, payload
})

export const zeroSendOrderClear = () => ({ type: types.ZERO_SEND_ORDER_PLACE_CLEAR })

export const orderPlacedResponse = (payload) => ({
  type: types.ORDER_PLACED_RESPONSE, payload
})
export const orderPlacedClear = () => ({ type: types.ORDER_PLACED_CLEAR })

// Data fetch from cart page

export const cartPageDataClear = () => ({ type: types.CART_PAGE_DATA_CLEAR })

export const cartPageDataResponse = (payload) => ({type: types.CART_PAGE_DATA_RESPONSE, payload})


export const subscriptionCheckoutPage = (payload) => ({
  type: types.SUBSCRIPTION_CHECKOUT_PAGE, payload
})
export const subscriptionCheckoutPageClear = () => ({ type: types.SUBSCRIPTION_CHECKOUT_PAGE_CLEAR })

export const providerSubscriptionCheckoutPage = (payload) => ({
  type: types.PROVIDER_CHECKOUT_SUBSCRIPTION_PAGE, payload
})
export const providerSubscriptionCheckoutPageClear = () => ({ type: types.PROVIDER_CHECKOUT_SUBSCRIPTION_PAGE_CLEAR })

export const fetchSubscriptionPIPage = (payload) => ({
  type: types.FETCH_SUBSCRIPTION_PI, payload
})
export const fetchSubscriptionPIPageRes = (payload) => ({
  type: types.FETCH_SUBSCRIPTION_PI_RES, payload
})
export const fetchSubscriptionPIPageClear = () => ({ type: types.FETCH_SUBSCRIPTION_PI_CLEAR })

export const paymentUpdateMembershipPage = (payload) => ({
  type: types.B2C_MEMBERSHIP_PAYMENT_UPDATE, payload
})
export const paymentUpdateMembershipPageRes = (payload) => ({
  type: types.B2C_MEMBERSHIP_PAYMENT_UPDATE_RES, payload
})
export const paymentUpdateMembershipPageClear = () => ({ type: types.B2C_MEMBERSHIP_PAYMENT_UPDATE_CLEAR })

export const membershipPaymentDetail = (payload) => ({
  type: types.MEMBERSHIP_PAYMENT_DETAIL, payload
})
export const membershipPaymentDetailClear = () => ({ type: types.MEMBERSHIP_PAYMENT_DETAIL_CLEAR })

export const productPaymentDetail = (payload) => ({
  type: types.PRODUCT_PAYMENT_DETAIL, payload
})
export const productPaymentDetailClear = () => ({ type: types.PRODUCT_PAYMENT_DETAIL_CLEAR })

export const providerPaymentDetail = (payload) => ({
  type: types.PROVIDER_PAYMENT_DETAIL, payload
})
export const providerPaymentDetailClear = () => ({ type: types.PROVIDER_PAYMENT_DETAIL_CLEAR })

export const fetchSubscribedData = (payload) => ({
  type: types.FETCH_SUBSCRIBED_DATA, payload
})
export const fetchSubscribedDataRes = (payload) => ({
  type: types.FETCH_SUBSCRIBED_DATA_RES, payload
})
export const fetchSubscribedDataClear = () => ({ type: types.FETCH_SUBSCRIBED_DATA_CLEAR })

export const changeSubscriptionPlan = (payload) => ({
  type: types.CHANGE_SUBSCRIPTION_PLAN, payload
})
export const changeSubscriptionPlanRes = (payload) => ({
  type: types.CHANGE_SUBSCRIPTION_PLAN_RES, payload
})
export const changeSubscriptionPlanClear = () => ({ type: types.CHANGE_SUBSCRIPTION_PLAN_CLEAR })

export const fetchSubscribedReceipt = (payload) => ({
  type: types.VIEW_SUBSCRIPTION_RECEIPT, payload
})
export const fetchSubscribedReceiptRes = (payload) => ({
  type: types.VIEW_SUBSCRIPTION_RECEIPT_RES, payload
})
export const fetchSubscribedReceiptClear = () => ({ type: types.VIEW_SUBSCRIPTION_RECEIPT_CLEAR })

export const setPreSubscriptionReceiptData = (payload) => ({
  type: types.PRE_SUBSCRIPTION_RECEIPT_DATA, payload
})
export const setPreSubscriptionReceiptDataClear = (payload) => ({
  type: types.PRE_SUBSCRIPTION_RECEIPT_DATA_CLEAR, payload
})